export function openMomIframeTab (tabs, route) {
  if (!route || !route.meta || !route.meta.momSubapp || !route.fullPath) {
    return tabs
  }
  if (tabs.some(tab => tab.fullPath === route.fullPath)) {
    return tabs
  }
  return tabs.concat({
    fullPath: route.fullPath,
    name: route.name,
    routeMeta: route.meta,
    routeQuery: { ...(route.query || {}) },
    instanceKey: 0
  })
}

export function refreshMomIframeTab (tabs, fullPath) {
  return tabs.map(tab => {
    return tab.fullPath === fullPath
      ? { ...tab, instanceKey: tab.instanceKey + 1 }
      : tab
  })
}

export function closeMomIframeTabs (tabs, fullPaths) {
  const removed = new Set(fullPaths || [])
  return tabs.filter(tab => !removed.has(tab.fullPath))
}
